export default {
  changeSwitchGrid({commit}) {
    commit('CHANGE_SWITCH_GRID')
  },

  changeGridSize({commit}, size) {
    commit('CHANGE_GRID_SIZE', size)
  },
}
